/**
 * Public store listings for the native Docio app (Capacitor shell, bundle id `health.docio.app`).
 *
 * The iOS listing is published by Docio Health Ltd under Apple id 6791935041. Link to the
 * country-agnostic URL so Apple redirects each visitor to their own storefront.
 */
export const APP_STORE_APP_ID = '6791935041';
export const APP_STORE_URL = `https://apps.apple.com/app/id${APP_STORE_APP_ID}`;
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=health.docio.app&pli=1';
